import { queryClient } from 'App';
import debounce from 'lodash/debounce';

import { socket } from 'lib/clients/socket';
import { COMMUNICATION_LOGS_QUERY_KEY } from 'lib/constants/queries/queryKeys';
import {
  invalidateAllAppointments,
  invalidateForCreate
} from 'lib/queries/appointmentInvalidation';

const flushAllAppointments = debounce(() => invalidateAllAppointments(queryClient), 300);

export default (data) => {
  const { appointment, patientId, from } = data ?? {};

  queryClient.invalidateQueries({ queryKey: [COMMUNICATION_LOGS_QUERY_KEY], exact: false });

  // Our own echo — the creating mutation already refreshed what it owns.
  if (from && socket?.id && from === socket.id) return;

  if (appointment?.id == null && patientId == null && appointment?.user_id == null) {
    flushAllAppointments();
    return;
  }

  invalidateForCreate(queryClient, {
    id: appointment?.id,
    patientId: patientId ?? appointment?.user_id,
    startsAt: appointment?.starts_at
  });
};
